var raf = require('raf');

function scrollTo(Y, duration, easingFunction, callback) {
    var start = Date.now(),
    	elem = document.documentElement.scrollTop?document.documentElement:document.body,
    	from = elem.scrollTop;
 
    if(from === Y) {
        callback();
        return; /* Prevent scrolling to the Y point if already there */
    }
 
    function min(a,b) {
    	return a<b?a:b;
    }
 
    function scroll(timestamp) {
 
        var currentTime = Date.now(),
            time = Math.min(1, ((currentTime - start) / duration)),
            easedT = easingFunction(time);
 
        elem.scrollTop = (easedT * (Y - from)) + from;
 
        if(time < 1) raf(scroll);
        else
            if(callback) callback();
    }
 
    raf(scroll)
}

module.exports = scrollTo;


/** WEBPACK FOOTER **
 ** ./src/scripts/lib/scrollTo.js
 **/